export default __webpack_public_path__ + "static/media/icon_wave.dd3aa470.svg";